import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppVersionComponent } from './version/version.component';

const routes: Routes = [
  { path: '', loadChildren: './auth/auth.module#AuthModule' },
  {
    path: 'strategies',
    loadChildren: './strategies/strategies.module#StrategiesModule'
  },
  {
    path: 'manage-users',
    loadChildren: './user-mgmt/user-mgmt.module#UserMgmtModule'
  },
  {
    path: 'resources',
    loadChildren: './resources/resources.module#ResourcesModule'
  },
  { path: 'version', component: AppVersionComponent }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})

export class AppRoutingModule { }
